import React from 'react';
import { Breadcrumb } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import DetailOptionList from '../../components/DetailOption/DetailOptionList';

const DetailOptionListPage = () => {
    return (
        <>
            <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-xl-0">
                    <Breadcrumb className="d-none d-md-inline-block"
                        listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                        <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                        <Breadcrumb.Item>Configuración</Breadcrumb.Item>
                        <Breadcrumb.Item active>Listado DetailOptions</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>Listado completo de opciones</h4>
                    <p className="mb-0">
                        Busque y explore todas las opciones de detalle registradas en el sistema.
                    </p>
                </div>
            </div>

            <DetailOptionList />
        </>
    );
};

export default DetailOptionListPage;
